var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer px-6"},[_c('b-row',{staticClass:"justify-content-lg-between",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"lg":"6"}},[_c('div',{staticClass:"copyright text-center text-lg-left text-muted"},[_vm._v("\n        © "+_vm._s(_vm.year)+" Mídia Festival\n      ")])]),_c('b-col',{attrs:{"lg":"6"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }